module.exports = __webpack_public_path__ + "static/media/forgotPassword.639dc484.jpg";